import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../api/supabase';

const typeColor = { Hotel: 'badge-blue', Airline: 'badge-purple', 'Visa Agent': 'badge-yellow', 'Land Operator': 'badge-green', Insurance: 'badge-blue', Other: 'badge-gray' };

export default function SupplierList() {
  const [suppliers, setSuppliers] = useState([]);
  const [q, setQ] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    let query = supabase.from('suppliers').select('*').order('name');
    if (q) query = query.or(`name.ilike.%${q}%,supplier_code.ilike.%${q}%,contact_person.ilike.%${q}%`);
    if (typeFilter) query = query.eq('supplier_type', typeFilter);
    const { data } = await query;
    // Sub-suppliers are only a grouping label under the supplier we actually owe (e.g.
    // Arabian Lux under Rajabdeen Haji) — they're listed under their parent, not as
    // suppliers of their own.
    const all = data || [];
    const subsByParent = {};
    all.filter(s => s.parent_supplier_id && s.is_active).forEach(s => { (subsByParent[s.parent_supplier_id] ||= []).push(s.name); });
    setSuppliers(all.filter(s => !s.parent_supplier_id).map(s => ({ ...s, subs: subsByParent[s.id] || [] })));
    setLoading(false);
  }, [q, typeFilter]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Suppliers</div><div className="page-subtitle">Hotels, airlines, visa agents, land operators</div></div>
        <Link to="/suppliers/new" className="btn btn-primary">+ New Supplier</Link>
      </div>
      <div className="card">
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
          <input className="form-input" placeholder="Search supplier..." value={q} onChange={e => setQ(e.target.value)} style={{ maxWidth: 300 }} />
          <div style={{ display: 'flex', gap: 6 }}>
            {['', 'Hotel', 'Airline', 'Visa Agent', 'Land Operator', 'Insurance', 'Other'].map(t => (
              <button key={t} className={`btn btn-sm ${typeFilter === t ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTypeFilter(t)}>{t || 'All'}</button>
            ))}
          </div>
        </div>
        {loading ? <div className="spinner" /> : (
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Code</th><th>Name</th><th>Type</th><th>Contact</th><th>Email</th><th>Phone</th><th>Country</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {suppliers.map(s => (
                  <tr key={s.id}>
                    <td><span style={{ fontFamily: 'monospace', color: 'var(--text-muted)' }}>{s.supplier_code}</span></td>
                    <td style={{ fontWeight: 500 }}>
                      {s.name}
                      {s.subs.length > 0 && <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 400 }}>Sub-suppliers: {s.subs.join(', ')}</div>}
                    </td>
                    <td><span className={`badge ${typeColor[s.supplier_type] || 'badge-gray'}`}>{s.supplier_type || 'Other'}</span></td>
                    <td>{s.contact_person || ''}</td>
                    <td style={{ color: 'var(--text-muted)' }}>{s.email || ''}</td>
                    <td style={{ color: 'var(--text-muted)' }}>{s.phone || ''}</td>
                    <td>{s.country || ''}</td>
                    <td><span className={`badge ${s.is_active ? 'badge-green' : 'badge-gray'}`}>{s.is_active ? 'Active' : 'Inactive'}</span></td>
                    <td><Link to={`/suppliers/${s.id}`} className="btn btn-secondary btn-sm">View</Link></td>
                  </tr>
                ))}
                {suppliers.length === 0 && <tr><td colSpan={9}><div className="empty-state"><div className="empty-state-title">No suppliers found</div></div></td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
